export const ActionTypes = {
    UPDATE_INDIRECT_SCORE: "UPDATE_INDIRECT_SCORE_REQUEST",
    UPDATE_INDIRECT_SCORE_SUCCESS: "UPDATE_INDIRECT_SCORE_SUCCESS",
    UPDATE_INDIRECT_SCORE_FAILURE: "UPDATE_INDIRECT_SCORE_FAILURE",
}